export default __webpack_public_path__ + "static/media/SHOT4.85c12d25.png";